<script setup>
import { computed } from "vue";

/**
 * Props, emits
 */
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

/**
 * Computed
 */
// Безопасный рендер номера. Для соответствующего шаблону значения собираем html
// ТОЛЬКО из regex-валидированных частей (кириллица + цифры — HTML-символы невозможны),
// поэтому v-html здесь безопасен. Несоответствующее (сырое) значение рендерим как ТЕКСТ
// (раньше оно уходило в v-html напрямую → XSS).
const formattedValue = computed(() => {
  const value = props.data.registration_number;
  if (!value) return { text: "" };

  // Например: М892ОК -> М<b>892</b>ОК
  const match = value.match(/^([А-Я]*)([0-9]*)([А-Я]*)$/i);

  if (match && match.length >= 4) {
    const [, prefix, numbers, suffix] = match;
    return { html: `${prefix}<b>${numbers}</b>${suffix}` };
  }

  return { text: value };
});

const reverse = computed(() => false);
</script>

<template>
  <div class="car-number" :class="{ 'car-number--reverse': reverse }">
    <span v-if="data.country" class="car-number__region-name">{{ data.country }}</span>
    <span v-if="formattedValue.html" class="car-number__value" v-html="formattedValue.html"></span>
    <span v-else class="car-number__value">{{ formattedValue.text }}</span>
    <span v-if="data.region" class="car-number__region-number">{{ data.region }}</span>
  </div>
</template>

<style lang="stylus">
.car-number {
	padding: 4px 10px
	border-radius: 6px;
	background: var(--gray-2);
	align-self flex-start
	display flex
	align-items center
	gap: 8px
	line-height: normal;
	color: var(--black, #000);

  &--reverse {
    flex-direction: row-reverse;
  }

	&__region-name {
		font-size: 0.875rem
	}

	&__value {
		font-family: Montserrat;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}

	&__region-number {
		padding: 2px
		border-left 1px solid var(--black)
		height 20px
		text-align: center;
		font-size: 0.75rem
		font-weight: 500;
		line-height: normal;

    ^[0]--reverse & {
      border-left 0
      border-right 1px solid var(--black)
    }
	}
}
</style>
